import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	topWave: {
		backgroundColor: theme.palette.neutral[5],
	},
	bottomWave: {
		backgroundColor: 'inherit',
	},
	section: {
		padding: `${theme.spacing.xlarge} 0`,
		backgroundColor: theme.palette.yellow[20],
	},
	container: {
		maxWidth: theme.section.width.lg,
		margin: 'auto',
		padding: `0 ${theme.spacing.small}`,
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,

		[getFromBreakpoint('md')]: {
			gap: theme.spacing.medium,
		},
	},
	header: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: theme.spacing.large,
	},
	headerTop: {
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: theme.spacing.medium,
	},
	title: {
		color: theme.review.section.heading.color.dimmed,
	},
	accommodationName: {
		color: theme.review.section.heading.color.default,
	},
	noReviewsText: {
		color: theme.review.section.heading.color.default,
	},
	score: {
		padding: 0,
	},
	scoreLabel: {
		font: theme.userScore.label.xSmall,
		color: `${theme.userScore.foreground.color.mediocre}!important`,

		[getFromBreakpoint('md')]: {
			font: theme.userScore.label.large,
		},
	},
	scoreTemplate: {
		display: 'flex',
		gap: theme.spacing.tiny,
		font: theme.typography.bodyMd,
		color: theme.body.foreground.color.dimmed,
	},
	scoreReviewCount: {
		font: theme.typography.linkSm,
		color: theme.link.color.light.default,
		textDecoration: 'underline',
	},
	block: {
		width: '100%',
		display: 'flex',
		alignItems: 'start',
		flexDirection: 'column',
		justifyContent: 'space-between',
		gap: theme.spacing.small,
		boxSizing: 'border-box',
		padding: theme.spacing.small,
		backgroundColor: theme.review.background.color,
		boxShadow: theme.review.elevation,
		borderRadius: theme.borderRadius.rounded,

		[getFromBreakpoint('md')]: {
			alignItems: 'center',
			flexDirection: 'row',
		},
	},
	writeReviewLeft: {
		margin: 0,
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.xsmall,
		color: theme.palette.neutral[60],
	},
	reviewCount: {
		margin: 0,
		font: theme.typography.headingMd,
		color: theme.palette.neutral[60],
		height: theme.spacing.xlarge,
		display: 'flex',
		alignItems: 'center',

		[getFromBreakpoint('md')]: {
			height: theme.spacing.xxlarge,
		},
	},
	reviews: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
	},
	loadMore: {
		width: 'fit-content',
		margin: `${theme.spacing.xxsmall} auto 0`,
	},
	reviewBtn: {
		textDecoration: 'none',
	},
	banner: {
		width: '100%',
		height: 'auto',
	},
	ratingContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
		padding: theme.spacing.small,
		backgroundColor: theme.review.background.color,
		boxShadow: theme.review.elevation,
		borderRadius: theme.borderRadius.rounded,
	},
}));
